import React, { PureComponent } from "react";
import clsx from "clsx";
import {
  CustomizedYAxisTickTime,
  Error,
  selectFormat,
  StandardTooltip,
  formatDateFromData,
  isDateFromDataInISOFormat,
  CustomizedXAxisTickTimeDay,
  MAIN_COLORS,
  getAllKeys,
} from "../Utils/Utils.js";

import {
  Line,
  LineChart,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

class LinesChartTime extends PureComponent {
  componentDidMount() {
    this.props.childRef(this);
  }

  getExportData = () => {
    return {
      data: this.props.data.data,
      opts: {
        type: "chart",
        date: {
          defined: isDateFromDataInISOFormat(this.props.data.graph),
          format: "YYYY-MM-DDThh:mm:ssZ",
          viewFormat: "YYYY-MM-DD",
        },
      },
    };
  };

  legendElement = (data) =>
    data.map((entry, i) => (
      <span key={i} className="legend mt-2 mt-md-0">
        <span
          className="legend__icon"
          style={{ background: MAIN_COLORS[i] }}
        ></span>
        <span className="legend__text" style={{ color: MAIN_COLORS[i] }}>
          {entry}
        </span>
      </span>
    ));

  getSortedKeys = (_data) => {
    if (!_data) return [];
    if (!_data[0]) return [];
    const data = _data.filter((d) => d);

    const keys = getAllKeys(data, ["date", "full_date"]);
    const len = data.length;

    return keys
      .map((key) => ({
        key: key,
        value: data.reduce((accum, curr) => accum + (curr[key] || 0), 0) / len,
      }))
      .sort((a, b) => b.value - a.value)
      .map((d) => d.key);
  };

  renderLegends = (data) => {
    let legends = [];
    let all_legends = [];

    const sortedKeys = this.getSortedKeys(data);

    for (let i = 0, j = data.length; i <= j - 1; i++) {
      sortedKeys.forEach((source) => all_legends.push(source));
    }

    legends = [...new Set(all_legends)];
    return this.legendElement(legends);
  };

  renderLines(data) {
    const allLines = this.getSortedKeys(data);
    return allLines.map((field, idx) => (
      <Line
        key={idx}
        type="monotone"
        dataKey={field}
        stroke={MAIN_COLORS[idx]}
        scale="auto"
        dot={false}
        isAnimationActive={false}
      />
    ));
  }

  render() {
    const { data } = this.props.data;

    if (data.hasData === false) {
      return <Error minHeight={380} />;
    }

    let preparedData = formatDateFromData(this.props.data.data, "YYYY/MM/DD");

    return (
      <>
        {this.renderLegends(preparedData)}
        <ResponsiveContainer height={380}>
          <LineChart
            data={preparedData}
            margin={{
              top: 20,
              right: 20,
              left: -40,
              bottom: 0,
            }}
          >
            <Tooltip
              cursor={{ fill: "#eee", opacity: 0.5 }}
              content={
                <StandardTooltip
                  render={({ data }) => {
                    const payload = data(this.props);

                    if (payload !== null) {
                      const tooltip_data = payload[0].payload;

                      return (
                        <div className="standard-tooltip">
                          {tooltip_data && tooltip_data.date && (
                            <header className="standard-tooltip__header">
                              <span className="standard-tooltip__key-header">
                                Date:
                              </span>
                              <span className="standard-tooltip__value-header">
                                {tooltip_data.date}
                              </span>
                            </header>
                          )}
                          <main className="standard-tooltip__main">
                            {Object.keys(payload)
                              .sort(
                                (a, b) => payload[b].value - payload[a].value
                              )
                              .map((key, index) => (
                                <div
                                  className="standard-tooltip__item"
                                  key={key}
                                >
                                  <span
                                    className="standard-tooltip__icon"
                                    style={{
                                      background: MAIN_COLORS[index],
                                    }}
                                  />
                                  <span
                                    className={clsx(
                                      "standard-tooltip__key",
                                      "text-capitalize"
                                    )}
                                    style={{ color: MAIN_COLORS[index] }}
                                  >
                                    {payload[key].dataKey}{" "}
                                  </span>
                                  <span className="standard-tooltip__value">
                                    {selectFormat(
                                      "secondsToHoursSeconds",
                                      payload[key].value
                                    )}
                                  </span>
                                </div>
                              ))}
                          </main>
                        </div>
                      );
                    }
                  }}
                />
              }
            />
            <CartesianGrid
              stroke="#FEE5DE"
              strokeDasharray="3 3"
              vertical={false}
            />
            {this.renderLines(preparedData)}
            {/* <Line
              type="monotone"
              dataKey="High"
              stroke={MAIN_COLORS[0]}
              scale="auto"
              dot={false}
              isAnimationActive={false}
            />
            <Line
              type="monotone"
              dataKey="Med"
              stroke={MAIN_COLORS[1]}
              scale="auto"
              dot={false}
              isAnimationActive={false}
            />
            <Line
              type="monotone"
              dataKey="Low"
              stroke={MAIN_COLORS[2]}
              scale="auto"
              dot={false}
              isAnimationActive={false}
            />
            <Line
              type="monotone"
              dataKey="null"
              stroke={MAIN_COLORS[3]}
              scale="auto"
              dot={false}
              isAnimationActive={false}
            /> */}
            <XAxis
              axisLine={false}
              tickLine={false}
              dataKey="date"
              interval={0}
              tick={<CustomizedXAxisTickTimeDay />}
            />
            <YAxis
              axisLine={false}
              tickLine={false}
              tick={<CustomizedYAxisTickTime />}
            />
          </LineChart>
        </ResponsiveContainer>
      </>
    );
  }
}

export default LinesChartTime;
